import React from 'react';
import PropTypes from 'prop-types';
import request from '../../utils/agent';
import { Formik, Field, FieldArray, Form } from 'formik';
import Loader from 'components/Loader';
import * as Yup from 'yup';
import './AdminCreateReseller.scss';


export default class AdminCreateReseller extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            role: 'user',
            isError: false,
            isSubmited: false,
            geo: null,
            lat: null,
            long: null,
            address_status: "",
            address: "",
            city: "",
            postal: "",
            country: "",
            state: "",
            touched: {
                address: false,
                city: false,
                postal: false,
                country: false,
                state: false,
            }
        };
    }


    componentDidMount() {
        var script = document.createElement('script');
        script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAf6G6eJvy-QDsPf9-ssNiykkMH89Fbbgo&libraries=places";
        document.getElementsByTagName('head')[0].appendChild(script);
    }



    componentDidUpdate() {
        this.addressListener();
        if(this.state.isSubmited === true) {
            this.setState({isSubmited: false})
        }

    }

    addressListener = (setFieldValue) => {
        const autocompleteFormField = document.getElementById(`addressAutocomplete.street`);

        const autocomplete = new google.maps.places.Autocomplete((autocompleteFormField), {
            types: [`address`]
        });

        google.maps.event.addListener(autocomplete, `place_changed`, () => {
            const place = autocomplete.getPlace();
            let ac = place.address_components;
            var address = {
                country: ac.filter(c => ~c.types.indexOf('country'))[0].short_name,
                street: place.name,
                city: ac.filter(c => ~c.types.indexOf('locality'))[0].long_name,
                state: ac.filter(c => ~c.types.indexOf('administrative_area_level_1'))[0].short_name,
                postal: ac.filter(c => ~c.types.indexOf('postal_code'))[0].short_name
            };

            //console.log(address); // This is our address selected component

            // I don't know how you would pass these to Formik.
            for(let key in address) {
                try {
                    document.getElementById(`addressAutocomplete.${key}`).value = address[key];
                    this.setState({
                        address: address.street,
                        city: address.city,
                        postal: address.postal,
                        country: address.country,
                        state: address.state,
                    })
                } catch(e) {
                    console.log(`Unable to set addressAutocomplete.${key}:${address[key]}`);
                }
            }

        });
    };

    handleAdrChange = (e) => {
        e.preventDefault();
        this.setState({
            address: e.target.value,
        })
    };
    handleCountryChange = (e) => {
        e.preventDefault();
        this.setState({
            country: e.target.value,
        })
    };
    handleCityChange = (e) => {
        e.preventDefault();
        this.setState({
            city: e.target.value,
        })
    };
    handleStateChange = (e) => {
        e.preventDefault();
        this.setState({
            state: e.target.value,
        })
    };
    handlePostalChange = (e) => {
        e.preventDefault();
        this.setState({
            postal: e.target.value,
        })
    };

    handleAdrBlur = (fieldName) => (e) => {
        this.setState({
            touched: {
                ...this.state.touched, [fieldName]: true
            },
        })
    };

    validateAdr(address, city, state, postal, country){
        return {
            address: address.length === 0,
            city: city.length === 0,
            state: state.length === 0,
            postal: postal.length === 0,
            country: country.length === 0,
        };
    };

    handleSubmitErr(e) {
        e.preventDefault();
        this.setState({
            touched: {
                address: true,
                city: true,
                postal: true,
                country: true,
                state: true,
            }
        })
    };

    handleVerifyAddress = async(address, city, state, postal, country) => {
        //evt.preventDefault();
        let geoloc = await request.post(`/api/company/address/coordinates`)
            .send ({"address": {"address": address, "country": country, "city": city, "state": state, "postal": postal}
            })
            .then(resp => {
                //console.log('response',resp.body.geospatial);
                return resp.body;
            })
            .catch(err => {
                console.log(err);
            });

        //console.log('geoloc', geoloc);
        if (geoloc !== undefined) {
            this.setState({
                geo: geoloc.geospatial,
                lat: geoloc.latitude,
                long: geoloc.longitude,
                address_status: "valid",
            })
        }

    };

    render() {

        const errors = this.validateAdr(this.state.address, this.state.city, this.state.state, this.state.state, this.state.country);
        //console.log('errors', errors);

        const isDisabled = Object.keys(errors).some(x => errors[x]);
        //console.log('isDisabled', isDisabled);

        //console.log('touched', this.state.touched);

        const shouldShowError = (fieldName) => {
            const hasErr = errors[fieldName];
            const shouldShow = this.state.touched[fieldName];
            return hasErr ? shouldShow : false;
        };

        const countryOpts = [
            {id: '', display: 'Select Country*'},
            {id: 'US', display: 'USA'},
            {id: 'CA', display: 'Canada'},
        ];

       //console.log('countries', countryOpts);

        const caStateOpts = [
            { id: '', display: 'Select State*'},
            { id: 'AL', display: 'Alberta'},
            { id: 'BC', display: 'British Columbia'},
            { id: 'MA', display: 'Manitoba'},
            { id: 'NB', display: 'New Brunswik'},
            { id: 'NL', display: 'Newfoundlend and Labrador'},
            { id: 'NS', display: 'Nova Scotia'},
            { id: 'ON', display: 'Ontario'},
            { id: 'PEI', display: 'Price Edward Island'},
            { id: 'QU', display: 'Quebeck'},
            { id: 'SA', display: 'Saskatchewan'},
        ];

        const usStateOpts = [
            { id: '', display: 'Select State*'},
            { id: 'AK', display: 'Alaska'},
            { id: 'AZ', display: 'Arizona'},
            { id: 'AR', display: 'Arkansas'},
            { id: 'CA', display: 'California'},
            { id: 'CO', display: 'Colorado'},
            { id: 'CT', display: 'Connecticut'},
            { id: 'DC', display: 'District of Columbia'},
            { id: 'DE', display: 'Delaware'},
            { id: 'FL', display: 'Florida'},
            { id: 'GA', display: 'Georgia'},
            { id: 'HI', display: 'Hawaii'},
            { id: 'ID', display: 'Idaho'},
            { id: 'IA', display: 'Iowa'},
            { id: 'IL', display: 'Illinois'},
            { id: 'IN', display: 'Indiana'},
            { id: 'KS', display: 'Kansas'},
            { id: 'KY', display: 'Kentucky'},
            { id: 'LA', display: 'Louisiana'},
            { id: 'ME', display: 'Maine'},
            { id: 'MD', display: 'Maryland'},
            { id: 'MA', display: 'Massachusetts'},
            { id: 'MI', display: 'Michigan'},
            { id: 'MN', display: 'Minnesota'},
            { id: 'MS', display: 'Mississippi'},
            { id: 'MO', display: 'Missouri'},
            { id: 'MT', display: 'Montana'},
            { id: 'NE', display: 'Nebraska'},
            { id: 'NH', display: 'New Hampshire'},
            { id: 'NJ', display: 'New Jersey'},
            { id: 'NM', display: 'New Mexico'},
            { id: 'NV', display: 'Nevada'},
            { id: 'NY', display: 'New York'},
            { id: 'NC', display: 'North Carolina'},
            { id: 'ND', display: 'North Dakota'},
            { id: 'OH', display: 'Ohio'},
            { id: 'OK', display: 'Oklahoma'},
            { id: 'OR', display: 'Oregon'},
            { id: 'PA', display: 'Pennsylvania'},
            { id: 'RI', display: 'Rhode Island'},
            { id: 'SC', display: 'South Carolina'},
            { id: 'SD', display: 'South Dakota'},
            { id: 'TN', display: 'Tennessee'},
            { id: 'TX', display: 'Texas'},
            { id: 'UT', display: 'Utah'},
            { id: 'VT', display: 'Vermont'},
            { id: 'VA', display: 'Virginia'},
            { id: 'WA', display: 'Washington'},
            { id: 'WV', display: 'West Virginia'},
            { id: 'WI', display: 'Wisconsin'},
            { id: 'WY', display: 'Wyoming'}
        ];

        const operationRadOpts = [
            {id: "", display: "Coverage Area*"},
            {id: 7, display: "<10 miles"},
            {id: 8, display: "10-20 miles"},
            {id: 9, display: "20-30 miles"},
            {id: 10, display: "30-40 miles"},
            {id: 11, display: "40-50 miles"},
            {id: 12, display: ">50 miles"},
        ];

        const dayTitles = ['Mon', 'Tues', 'Weds', 'Thurs', 'Fri', 'Sat', 'Sun'];
        const closedAr = ['Closed', 'Closed', 'Closed', 'Closed', 'Closed', 'Closed', 'Closed'];

        const timeOpts = [
            {id: "", display: 'Set Hour'},
            {id: "0", display: '12:00 AM'},
            {id: "1", display: '1:00 AM'},
            {id: "2", display: '2:00 AM'},
            {id: "3", display: '3:00 AM'},
            {id: "4", display: '4:00 AM'},
            {id: "5", display: '5:00 AM'},
            {id: "6", display: '6:00 AM'},
            {id: "7", display: '7:00 AM'},
            {id: "8", display: '8:00 AM'},
            {id: "9", display: '9:00 AM'},
            {id: "10", display: '10:00 AM'},
            {id: "11", display: '11:00 AM'},
            {id: "12", display: '12:00 PM'},
            {id: "13", display: '1:00 PM'},
            {id: "14", display: '2:00 PM'},
            {id: "15", display: '3:00 PM'},
            {id: "16", display: '4:00 PM'},
            {id: "17", display: '5:00 PM'},
            {id: "18", display: '6:00 PM'},
            {id: "19", display: '7:00 PM'},
            {id: "20", display: '8:00 PM'},
            {id: "21", display: '9:00 PM'},
            {id: "22", display: '10:00 PM'},
            {id: "23", display: '11:00 PM'},
        ];

        const segmentOps = [
            {id: "commerical", display: "Commerical"},
            {id: "industrial", display: "Industrial"},
            {id: "residential", display: "Residential"},
        ];

        const servicesOpts = [
            {id: "audio_visual", display: "Audio/Visual"},
            {id: "high_voltage_install", display: "High Voltage Install"},
            {id: "low_voltage_install", display: "Low Voltage Install"},
            {id: "smart_home_install", display: "Smart Home Install"},
            {id: "wholehome_automation", display: "Wholehome Automation"},
        ];

        const refferalOpts = [
            {id: "customer", display: "Customer"},
            {id: "distributor", display: "Distributer"},
            {id: "email", display: "Email"},
            {id: "facebook", display: "Facebook"},
            {id: "instagram", display: "Instagram"},
            {id: "lighting_showroom", display: "Lighting Showroom"},
            {id: "print_ad", display: "Print Ad"},
            {id: "sales_rep", display: "Sales Rep"},
            {id: "tradeshow", display: "Tradeshow"},
            {id: "tv", display: "TV"},
            {id: "word_of_mouth", display: "Word of Mouth"},
        ];

        const ProfileSchema = Yup.object().shape({
            email: Yup.string().required('This value is required.').email('This value should be a valid email.'),
            first_name: Yup.string().required('This value is required.'),
            last_name: Yup.string().required('This value is required.'),
            name: Yup.string().required('This value is required.'),
            dba: Yup.string().required('This value is required.'),
            primary_jobtitle: Yup.string().required('This value is required.'),
            phone: Yup.string().required('This value is required.'),
            //country: Yup.string().required('This value is required.'),
            //address: Yup.string().required('This value is required.'),
            //city: Yup.string().required('This value is required.').matches(/^[a-zA-Z]*$/, 'This value should be alpha characters only'),
            //state: Yup.string().required('This value is required.'),
            //postal: Yup.string().required('This value is required.').matches(/^[a-zA-Z0-9]*$/, 'This value should be alphanumeric characters only'),
            domain: Yup.string().required('This value is required.').url('This value should be a valid url.'),
            years_in_business: Yup.string().required('This value is required.'),
            coverage_range: Yup.string().required('This value is required.'),
            coverage_segments: Yup.string().required('This value is required.'),
            services_offered: Yup.string().required('This value is required.'),
            number_of_employees: Yup.string().required('This value is required.'),
            primary_distributor: Yup.string().required('This value is required.'),
        });

       // console.log('submitted', this.state.isSubmited);


        return(
            <section className='profile--container'>
                <div className='profile-data'>
                    <div className='short-desc'>
                        <h3>New Reseller</h3>
                    </div>
                    {this.state.isSubmited === false ?
                        < div className='profile-details'>
                            <h3>Primary Contact Information</h3>
                            <Formik
                                initialValues={{
                                    email: "",
                                    first_name: "",
                                    last_name: "",
                                    name: "",
                                    dba: "",
                                    primary_jobtitle: "",
                                    phone: "",
                                    address: "",
                                    country: "",
                                    city: "",
                                    state: "",
                                    postal: "",
                                    domain: "",
                                    electrician_certification: "",
                                    reseller_certification: "",
                                    file: "",
                                    years_in_business: "",
                                    coverage_range: "",
                                    coverage_segments: "",
                                    services_offered: "",
                                    number_of_employees: "",
                                    primary_distributor: "",
                                    secondary_distributor: "",
                                    dealer_finder: false,
                                    experience_with_noon: false,
                                    additional_information_hearAboutNoon: "",

                                    mon_from: "",
                                    tues_from: "",
                                    weds_from: "",
                                    thurs_from: "",
                                    fri_from: "",
                                    sat_from: "",
                                    sun_from: "",

                                    mon_to: "",
                                    tues_to: "",
                                    weds_to: "",
                                    thurs_to: "",
                                    fri_to: "",
                                    sat_to: "",
                                    sun_to: "",

                                    mon_closed: false,
                                    tues_closed: false,
                                    weds_closed: false,
                                    thurs_closed: false,
                                    fri_closed: false,
                                    sat_closed: false,
                                    sun_closed: false,

                                    document_uuid: "",
                                    terms_agreement: false,
                                    prices_agreement: false,
                                    recaptcha: "",

                                }}
                                enableReinitialize={false}
                                validationSchema={ProfileSchema}
                                onSubmit={ async (values, actions) => {
                                    let coverage = parseInt(values.coverage_range, 10);
                                    let yearsInB = parseInt(values.years_in_business, 10);
                                    let numberOfE = parseInt(values.number_of_employees, 10);
                                    let hearedAbout = "";
                                    if (values.additional_information_hearAboutNoon != "" && values.additional_information_hearAboutNoon != []) {
                                        hearedAbout = values.additional_information_hearAboutNoon.join(",")
                                    }
                                  //  console.log('about N', hearedAbout);
                                    let cSegments = "";
                                    if (values.coverage_segments != "" && values.coverage_segments != []) {
                                        cSegments = values.coverage_segments.join(",")
                                    }
                                   // console.log('s segs', cSegments);

                                    let servicesO = "";
                                    if (values.services_offered != "" && values.services_offered != []) {
                                        servicesO = values.services_offered.join(",")
                                    }
                                   //console.log('services', servicesO);

                                    let data =  await this.handleVerifyAddress(this.state.address, this.state.city, this.state.state, this.state.postal, this.state.country,);


                                    return new Promise((resolve, reject) => {
                                        request.post('/api/createcompany')
                                            .send({
                                                role: 'user',
                                                email: values.email,
                                                username: values.email,
                                                first_name: values.first_name,
                                                last_name: values.last_name,
                                                document_uuid: values.document_uuid,
                                                additional_information_hearAboutNoon: hearedAbout,
                                                name: values.name,
                                                dba: values.dba,
                                                primary_jobtitle: values.primary_jobtitle,
                                                phone: values.phone,
                                                country: this.state.country,
                                                address: this.state.address,
                                                city: this.state.city,
                                                state: this.state.state,
                                                postal: this.state.postal,
                                                domain: values.domain,
                                                electrician_certification: values.electrician_certification,
                                                reseller_certification: values.reseller_certification,
                                                years_in_business: yearsInB,
                                                coverage_range: coverage,
                                                coverage_segments: cSegments,
                                                services_offered: servicesO,
                                                number_of_employees: numberOfE,
                                                dealer_finder: values.dealer_finder,
                                                primary_distributor: values.primary_distributor,
                                                secondary_distributor: values.secondary_distributor,
                                                experience_with_noon: values.experience_with_noon,
                                                address_status: this.state.address_status,
                                                latitude: this.state.lat,
                                                longitude: this.state.long,
                                                geospatial: this.state.geo,

                                                mon_from: values.mon_from,
                                                tues_from: values.tues_from,
                                                weds_from: values.weds_from,
                                                thurs_from: values.thurs_from,
                                                fri_from: values.fri_from,
                                                sat_from: values.sat_from,
                                                sun_from: values.sun_from,

                                                mon_to: values.mon_to,
                                                tues_to: values.tues_to,
                                                weds_to: values.weds_to,
                                                thurs_to: values.thurs_to,
                                                fri_to: values.fri_to,
                                                sat_to: values.sat_to,
                                                sun_to: values.sun_to,

                                                mon_closed: values.mon_closed,
                                                tues_closed: values.tues_closed,
                                                weds_closed: values.weds_closed,
                                                thurs_closed: values.thurs_closed,
                                                fri_closed: values.fri_closed,
                                                sat_closed: values.sat_closed,
                                                sun_closed: values.sun_closed,

                                                project_information_numberOfProjects: null,
                                                project_information_numberOfHomes: null,
                                                project_information_averageHomePrice: null,
                                                project_information_primaryHomeTypes: null,
                                                project_information_projectSize: null,
                                                project_information_projectCompletionDate: null,
                                                number_of_stores: null,
                                                business_coverage: null,
                                                business_type: null,
                                                speciality: null,
                                                provide_staff_training: null,

                                            })
                                            .then(data => {
                                                //console.log('finished user call');
                                                //console.log(data);
                                                this.setState({
                                                    isSubmited: true,
                                                    geo: null,
                                                    lat: null,
                                                    long: null,
                                                    address_status:'',
                                                });
                                            })
                                            .catch(err => {
                                                console.error(err);
                                                this.setState({isError: true});
                                            });

                                    });
                                }}>
                                {({
                                      values,
                                      errors,
                                      touched,
                                      handleChange,
                                      handleBlur,
                                      handleSubmit,
                                      isSubmitting,
                                      setFieldValue,
                                      handleReset,
                                      dirty,
                                      isValid,
                                      isValidating,

                                  }) => (
                                    <Form className='my-f-form' onSubmit={e => {
                                        handleSubmit(e);
                                        if(isDisabled === true) {
                                            this.handleSubmitErr(e)
                                        }
                                    }}>
                                        <label className='form-f-label'>Email*</label>
                                        <Field
                                            name='email'
                                            className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='Email*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.email}/>
                                        {errors.email && touched.email ?
                                            (<div className='f-field-errors'>{errors.email} </div>) : null
                                        }

                                        <div className='flex--fields--holder'>
                                            <div className='flex-field-container'>
                                                <label className='form-f-label'>First Name*</label>
                                                <div className='flex-with-error-holder'>
                                                    <Field
                                                        name='first_name'
                                                        component='input'
                                                        className={errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='First Name*'
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.first_name}
                                                    />
                                                    {errors.first_name && touched.first_name ? (
                                                        <div
                                                            className='f-field-errors'>{errors.first_name}</div>) : null
                                                    }
                                                </div>
                                            </div>

                                            <div className='flex-field-container last'>
                                                <label className='form-f-label'>Last Name*</label>
                                                <div className='flex-with-error-holder'>
                                                    <Field
                                                        name='last_name'
                                                        component='input'
                                                        className={errors.last_name && touched.last_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='Last Name*'
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.last_name}
                                                    />
                                                    {errors.last_name && touched.last_name ?
                                                        (<div
                                                            className='f-field-errors'>{errors.last_name}</div>) : null
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <h3 className='profile-data-section'>Business Information</h3>

                                        <label className='form-f-label'>Company Name*</label>
                                        <Field
                                            name='name'
                                            component='input'
                                            className={errors.name && touched.name ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='Company Name*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.name}
                                        />
                                        {errors.name && touched.name ?
                                            (<div className='f-field-errors'>{errors.name}</div>) : null
                                        }

                                        <label className='form-f-label'>Doing Business As (DBA)*</label>
                                        <Field
                                            name='dba'
                                            component='input'
                                            className={errors.dba && touched.dba ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='Doing Business As*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.dba}
                                        />
                                        {errors.dba && touched.dba ?
                                            (<div className='f-field-errors'>{errors.dba}</div>) : null
                                        }

                                        <label className='form-f-label'>Job Title*</label>
                                        <Field
                                            name='primary_jobtitle'
                                            component='input'
                                            className={errors.primary_jobtitle && touched.primary_jobtitle ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='Job Title*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.primary_jobtitle}
                                        />
                                        {errors.primary_jobtitle && touched.primary_jobtitle ?
                                            (<div className='f-field-errors'>{errors.primary_jobtitle}</div>) : null
                                        }

                                        <label className='form-f-label'>Primary Phone*</label>
                                        <Field
                                            name='phone'
                                            component='input'
                                            className={errors.phone && touched.phone ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='(___)___-____'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.phone}
                                        />
                                        {errors.phone && touched.phone ?
                                            (<div className='f-field-errors'>{errors.phone}</div>) : null
                                        }

                                        <label className='form-f-label'>Country*</label>
                                        <select
                                            id='addressAutocomplete.country'
                                            name='country'
                                            className='single-choice-selector'
                                            value={this.state.country}
                                            onChange={e => this.handleCountryChange(e)}
                                            onBlur={this.handleAdrBlur('country')}
                                        >
                                            {countryOpts.map(option => (
                                                <option key={`country-${option.id}`} value={option.id}>
                                                    {option.display}
                                                </option>
                                            ))}
                                        </select>
                                        {shouldShowError('country') ?
                                            (<div className='f-field-errors'>This value is required.</div>) : null
                                        }

                                        <label className='form-f-label'>Address*</label>
                                        <input
                                            name='address'
                                            className={shouldShowError('address') ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            id='addressAutocomplete.street'
                                            placeholder='Address*'
                                            value={this.state.address}
                                            onChange={e => this.handleAdrChange(e)}
                                            onBlur={this.handleAdrBlur('address')}
                                        />
                                        {shouldShowError('address') ?
                                            (<div className='f-field-errors'>This value is required.</div>) : null
                                        }

                                        <div className='flex--fields--holder'>
                                            <div className='flex-field-container'>
                                                <label className='form-f-label'>City*</label>
                                                <input
                                                    name='city'
                                                    className={shouldShowError('city') ? 'form-f-field with-error' : 'form-f-field'}
                                                    type='text'
                                                    id='addressAutocomplete.city'
                                                    placeholder='City*'
                                                    value={this.state.city}
                                                    onChange={e => this.handleCityChange(e)}
                                                    onBlur={this.handleAdrBlur('city')}
                                                />
                                                {shouldShowError('city') ?
                                                    (<div className='f-field-errors'>This value is required.</div>) : null
                                                }
                                            </div>

                                            {this.state.country === 'CA' ?
                                                <div className='flex-field-container'>
                                                    <label className='flex-form-label'>State*</label>
                                                    <select
                                                        name='state'
                                                        id='addressAutocomplete.state'
                                                        className='state-selector'
                                                        placeholder='State'
                                                        value={this.state.state}
                                                        onChange={e => this.handleStateChange(e)}
                                                        onBlur={this.handleAdrBlur('state')}
                                                    >
                                                        {caStateOpts.map(option => (
                                                            <option key={`state-${option.id}`}
                                                                    value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {shouldShowError('state') ?
                                                        (<div className='f-field-errors'>This value is required.</div>) : null
                                                    }
                                                </div>:
                                                <div className='flex-field-container'>
                                                    <label className='flex-form-label'>State*</label>
                                                    <select
                                                        name='state'
                                                        id='addressAutocomplete.state'
                                                        className='state-selector'
                                                        placeholder='State'
                                                        value={this.state.state}
                                                        onChange={e => this.handleStateChange(e)}
                                                        onBlur={this.handleAdrBlur('state')}
                                                    >
                                                        {usStateOpts.map(option => (
                                                            <option key={`state-${option.id}`}
                                                                    value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {shouldShowError('state') ?
                                                        (<div className='f-field-errors'>This value is required.</div>) : null
                                                    }
                                                </div>
                                            }

                                            <div className='flex-field-container last'>
                                                <label className='form-f-label'>Postal Code*</label>
                                                <input
                                                    name='postal'
                                                    id='addressAutocomplete.postal'
                                                    className={shouldShowError('postal') ? 'form-f-field with-error' : 'form-f-field'}
                                                    type='text'
                                                    placeholder='Postal Code*'
                                                    value={this.state.postal}
                                                    onChange={e => this.handlePostalChange(e)}
                                                    onBlur={this.handleAdrBlur('postal')}
                                                />
                                                {shouldShowError('postal') ?
                                                    (<div className='f-field-errors'>This value is required.</div>) : null
                                                }
                                            </div>
                                        </div>

                                        <label className='form-f-label'>Website*</label>
                                        <Field
                                            name='domain'
                                            component='input'
                                            className={errors.domain && touched.domain ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='Website*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.domain}
                                        />
                                        {errors.domain && touched.domain ?
                                            (<div className='f-field-errors'>{errors.domain}</div>) : null
                                        }

                                        <label className='form-f-label'>Electrician License Number</label>
                                        <input className='form-f-field'
                                               type='text'
                                               name='electrician_certification'
                                               placeholder='Electrician License Number'
                                               onChange={handleChange}
                                               onBlur={handleBlur}
                                               value={values.electrician_certification}
                                        />

                                        <label className='form-f-label'>Reseller License Number</label>
                                        <input className='form-f-field'
                                               type='text'
                                               name='reseller_certification'
                                               placeholder='Reseller License Number'
                                               onChange={handleChange}
                                               onBlur={handleBlur}
                                               value={values.reseller_certification}
                                        />

                                        <p className='disclaimer--copy'>Specify your reseller tax number and state
                                            above and upload a copy of your reseller certificate below.
                                            If you sell in multiple states, please upload them as a zip file. If no
                                            reseller certificate is provided, applicable sales tax will be charged
                                            on your purchases.</p>


                                        <label className='form-f-label'>Years in Business*</label>
                                        <Field
                                            name='years_in_business'
                                            component='input'
                                            className={errors.years_in_business && touched.years_in_business ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='Years in Business*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.years_in_business}
                                        />
                                        {errors.years_in_business && touched.years_in_business ?
                                            (<div
                                                className='f-field-errors'>{errors.years_in_business}</div>) : null
                                        }

                                        <h3 className='profile-data-section'>Coverage Information</h3>

                                        <label className='form-f-label'>Hours of Operation</label>

                                        <div className='op-hours-container'>
                                            <div className='time-opts-table'>
                                                <div className='time-opt-row'>
                                                    <div className='titles-container'>
                                                        <div className='text-title'>Mon</div>
                                                    </div>
                                                    {values.mon_closed === true ?
                                                        <div className='time-selects-holder'>
                                                            <Field name='mon_from' component='select'
                                                                   className='open-time-selector not-active'
                                                                   disabled={true}>
                                                                {timeOpts.map(option => (
                                                                    <option key={`mon_from-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <Field name='mon_to' component='select'
                                                                   className='open-time-selector not-active'
                                                                   disabled={true}>
                                                                {timeOpts.map(option => (
                                                                    <option key={`mon_to-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div> :
                                                        <div className='time-selects-holder'>
                                                            <Field name='mon_from' component='select'
                                                                   className='open-time-selector'>
                                                                {timeOpts.map(option => (
                                                                    <option key={`mon_from-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <Field name='mon_to' component='select'
                                                                   className='open-time-selector'>
                                                                {timeOpts.map(option => (
                                                                    <option key={`mon_to-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                    }
                                                    <div className='check-boxes-holder'>
                                                        <Field className='closed--checkbox' type='checkbox'
                                                               name='mon_closed' checked={values.mon_closed}>
                                                        </Field>
                                                    </div>
                                                    <div className='titles-container'>
                                                        <div className='text-title'>Closed</div>
                                                    </div>
                                                </div>


                                                <div className='time-opt-row'>
                                                    <div className='titles-container'>
                                                        <div className='text-title'>Tues</div>
                                                    </div>
                                                    {values.tues_closed === true ?
                                                        <div className='time-selects-holder'>
                                                            <Field name='tues_from' component='select'
                                                                   className='open-time-selector not-active'
                                                                   disabled={true}>
                                                                {timeOpts.map(option => (
                                                                    <option key={`tues_from-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <Field name='tues_to' component='select'
                                                                   className='open-time-selector not-active'
                                                                   disabled={true}>
                                                                {timeOpts.map(option => (
                                                                    <option key={`tues_to-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div> :
                                                        <div className='time-selects-holder'>
                                                            <Field name='tues_from' component='select'
                                                                   className='open-time-selector'>
                                                                {timeOpts.map(option => (
                                                                    <option key={`tues_from-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <Field name='tues_to' component='select'
                                                                   className='open-time-selector'>
                                                                {timeOpts.map(option => (
                                                                    <option key={`tues_to-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                    }
                                                    <div className='check-boxes-holder'>
                                                        <Field className='closed--checkbox' type='checkbox'
                                                               name='tues_closed' checked={values.tues_closed}>
                                                        </Field>
                                                    </div>
                                                    <div className='titles-container'>
                                                        <div className='text-title'>Closed</div>
                                                    </div>
                                                </div>


                                                <div className='time-opt-row'>
                                                    <div className='titles-container'>
                                                        <div className='text-title'>Weds</div>
                                                    </div>
                                                    {values.weds_closed === true ?
                                                        <div className='time-selects-holder'>
                                                            <Field name='weds_from' component='select'
                                                                   className='open-time-selector not-active'
                                                                   disabled={true}>
                                                                {timeOpts.map(option => (
                                                                    <option key={`weds_from-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <Field name='weds_to' component='select'
                                                                   className='open-time-selector not-active'
                                                                   disabled={true}>
                                                                {timeOpts.map(option => (
                                                                    <option key={`weds_to-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div> :
                                                        <div className='time-selects-holder'>
                                                            <Field name='weds_from' component='select'
                                                                   className='open-time-selector'>
                                                                {timeOpts.map(option => (
                                                                    <option key={`weds_from-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <Field name='weds_to' component='select'
                                                                   className='open-time-selector'>
                                                                {timeOpts.map(option => (
                                                                    <option key={`weds_to-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                    }
                                                    <div className='check-boxes-holder'>
                                                        <Field className='closed--checkbox' type='checkbox'
                                                               name='weds_closed' checked={values.weds_closed}>
                                                        </Field>
                                                    </div>
                                                    <div className='titles-container'>
                                                        <div className='text-title'>Closed</div>
                                                    </div>
                                                </div>


                                                <div className='time-opt-row'>
                                                    <div className='titles-container'>
                                                        <div className='text-title'>Thurs</div>
                                                    </div>
                                                    {values.thurs_closed === true ?
                                                        <div className='time-selects-holder'>
                                                            <Field name='thurs_from' component='select'
                                                                   className='open-time-selector not-active'
                                                                   disabled={true}>
                                                                {timeOpts.map(option => (
                                                                    <option key={`thurs_from-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <Field name='thurs_to' component='select'
                                                                   className='open-time-selector not-active'
                                                                   disabled={true}>
                                                                {timeOpts.map(option => (
                                                                    <option key={`thurs_to-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div> :
                                                        <div className='time-selects-holder'>
                                                            <Field name='thurs_from' component='select'
                                                                   className='open-time-selector'>
                                                                {timeOpts.map(option => (
                                                                    <option key={`thurs_from-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <Field name='thurs_to' component='select'
                                                                   className='open-time-selector'>
                                                                {timeOpts.map(option => (
                                                                    <option key={`thurs_to-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                    }
                                                    <div className='check-boxes-holder'>
                                                        <Field className='closed--checkbox' type='checkbox'
                                                               name='thurs_closed' checked={values.thurs_closed}>
                                                        </Field>
                                                    </div>
                                                    <div className='titles-container'>
                                                        <div className='text-title'>Closed</div>
                                                    </div>

                                                </div>


                                                <div className='time-opt-row'>
                                                    <div className='titles-container'>
                                                        <div className='text-title'>Fri</div>
                                                    </div>
                                                    {values.fri_closed === true ?
                                                        <div className='time-selects-holder'>
                                                            <Field name='fri_from' component='select'
                                                                   className='open-time-selector not-active'
                                                                   disabled={true}>
                                                                {timeOpts.map(option => (
                                                                    <option key={`fri_from-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <Field name='fri_to' component='select'
                                                                   className='open-time-selector not-active'
                                                                   disabled={true}>
                                                                {timeOpts.map(option => (
                                                                    <option key={`fri_to-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div> :
                                                        <div className='time-selects-holder'>
                                                            <Field name='fri_from' component='select'
                                                                   className='open-time-selector'>
                                                                {timeOpts.map(option => (
                                                                    <option key={`fri_from-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <Field name='fri_to' component='select'
                                                                   className='open-time-selector'>
                                                                {timeOpts.map(option => (
                                                                    <option key={`fri_to-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                    }
                                                    <div className='check-boxes-holder'>
                                                        <Field className='closed--checkbox' type='checkbox'
                                                               name='fri_closed' checked={values.fri_closed}>
                                                        </Field>
                                                    </div>
                                                    <div className='titles-container'>
                                                        <div className='text-title'>Closed</div>
                                                    </div>
                                                </div>


                                                <div className='time-opt-row'>
                                                    <div className='titles-container'>
                                                        <div className='text-title'>Sat</div>
                                                    </div>
                                                    {values.sat_closed === true ?
                                                        <div className='time-selects-holder'>
                                                            <Field name='sat_from' component='select'
                                                                   className='open-time-selector not-active'
                                                                   disabled={true}>
                                                                {timeOpts.map(option => (
                                                                    <option key={`sat_from-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <Field name='sat_to' component='select'
                                                                   className='open-time-selector not-active'
                                                                   disabled={true}>
                                                                {timeOpts.map(option => (
                                                                    <option key={`sat_to-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div> :
                                                        <div className='time-selects-holder'>
                                                            <Field name='sat_from' component='select'
                                                                   className='open-time-selector'>
                                                                {timeOpts.map(option => (
                                                                    <option key={`sat_from-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <Field name='sat_to' component='select'
                                                                   className='open-time-selector'>
                                                                {timeOpts.map(option => (
                                                                    <option key={`sat_to-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                    }
                                                    <div className='check-boxes-holder'>
                                                        <Field className='closed--checkbox' type='checkbox'
                                                               name='sat_closed' checked={values.sat_closed}>
                                                        </Field>
                                                    </div>
                                                    <div className='titles-container'>
                                                        <div className='text-title'>Closed</div>
                                                    </div>
                                                </div>


                                                <div className='time-opt-row'>
                                                    <div className='titles-container'>
                                                        <div className='text-title'>Sun</div>
                                                    </div>
                                                    {values.sun_closed === true ?
                                                        <div className='time-selects-holder'>
                                                            <Field name='sun_from' component='select'
                                                                   className='open-time-selector not-active'
                                                                   disabled={true}>
                                                                {timeOpts.map(option => (
                                                                    <option key={`sun_from-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <Field name='sun_to' component='select'
                                                                   className='open-time-selector not-active'
                                                                   disabled={true}>
                                                                {timeOpts.map(option => (
                                                                    <option key={`sun_to-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div> :
                                                        <div className='time-selects-holder'>
                                                            <Field name='sun_from' component='select'
                                                                   className='open-time-selector'>
                                                                {timeOpts.map(option => (
                                                                    <option key={`sun_from-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                            <Field name='sun_to' component='select'
                                                                   className='open-time-selector'>
                                                                {timeOpts.map(option => (
                                                                    <option key={`sun_to-${option.id}`}
                                                                            value={option.id}>
                                                                        {option.display}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                    }
                                                    <div className='check-boxes-holder'>
                                                        <Field className='closed--checkbox' type='checkbox'
                                                               name='sun_closed' checked={values.sun_closed}>
                                                        </Field>
                                                    </div>
                                                    <div className='titles-container'>
                                                        <div className='text-title'>Closed</div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>


                                        <label className='form-f-label'>Coverage Area*</label>
                                        <Field name='coverage_range' component='select'
                                               className='single-choice-selector'>
                                            {operationRadOpts.map(option => (
                                                <option key={`coverage_range-${option.id}`} value={option.id}>
                                                    {option.display}
                                                </option>
                                            ))}
                                        </Field>
                                        {errors.coverage_range && touched.coverage_range ?
                                            (<div className='f-field-errors'>{errors.coverage_range}</div>) : null
                                        }

                                        <label className='form-f-label'>Coverage Segments*</label>
                                        <label className='second-f-label'>Select Options:</label>
                                        <div className='box--outline-comp'>
                                            <div className='checkbox-group-content'>
                                                <FieldArray
                                                    name='coverage_segments'
                                                    render={arrayHelpers => (
                                                        <div>
                                                            {segmentOps.map(option => (
                                                                <div key={option.id}>
                                                                    <input
                                                                        name='coverage_segments'
                                                                        type='checkbox'
                                                                        value={option.id}
                                                                        checked={values.coverage_segments.includes(option.id)}
                                                                        onChange={event => {
                                                                            if (event.target.checked) {
                                                                                arrayHelpers.push(option.id);
                                                                            }
                                                                            else {
                                                                                const idx = values.coverage_segments.indexOf(option.id);
                                                                                arrayHelpers.remove(idx);
                                                                            }
                                                                        }}
                                                                    /> {option.display}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        {errors.coverage_segments && touched.coverage_segments ?
                                            (<div
                                                className='f-field-errors'>{errors.coverage_segments}</div> ) : null
                                        }

                                        <label className='form-f-label'>Services Offered*</label>
                                        <label className='second-f-label'>Select Options:</label>
                                        <div className='box--outline-comp'>
                                            <div className='checkbox-group-content'>
                                                <FieldArray
                                                    name='services_offered'
                                                    render={arrayHelpers => (
                                                        <div>
                                                            {servicesOpts.map(option => (
                                                                <div key={option.id}>
                                                                    <input
                                                                        name='services_offered'
                                                                        type='checkbox'
                                                                        value={option.id}
                                                                        checked={values.services_offered.includes(option.id)}
                                                                        onChange={event => {
                                                                            if (event.target.checked) {
                                                                                arrayHelpers.push(option.id);
                                                                            }
                                                                            else {
                                                                                const idx = values.services_offered.indexOf(option.id);
                                                                                arrayHelpers.remove(idx);
                                                                            }
                                                                        }}
                                                                    /> {option.display}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        {errors.services_offered && touched.services_offered ?
                                            (<div className='f-field-errors'>{errors.services_offered}</div>) : null
                                        }

                                        <label className='form-f-label'>Number of Employees*</label>
                                        <Field
                                            name='number_of_employees'
                                            component='input'
                                            className={errors.number_of_employees && touched.number_of_employees ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='Number of Employees*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.number_of_employees}
                                        />
                                        {errors.number_of_employees && touched.number_of_employees ?
                                            (<div
                                                className='f-field-errors'>{errors.number_of_employees}</div>) : null
                                        }

                                        <div className='toggle-switch-gr'>
                                            <input
                                                type='checkbox'
                                                className='toggle--input--btn'
                                                name='dealer_finder'
                                                checked={values.dealer_finder}
                                                onChange={handleChange}
                                            />
                                            <p className='toggle-in-label'>Add to NOON finder?</p>
                                        </div>

                                        <h3 className='profile-data-section'>Additional Information</h3>

                                        <label className='form-f-label'>Primary Distributor*</label>
                                        <Field
                                            name='primary_distributor'
                                            component='input'
                                            className={errors.primary_distributor && touched.primary_distributor ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='Primary Distributor*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.primary_distributor}
                                        />
                                        {errors.primary_distributor && touched.primary_distributor ?
                                            (<div
                                                className='f-field-errors'>{errors.primary_distributor}</div>) : null
                                        }

                                        <label className='form-f-label'>Secondary Distributor</label>
                                        <input className='form-f-field'
                                               type='text'
                                               name='secondary_distributor'
                                               placeholder='Secondary Distributor'
                                               onChange={handleChange}
                                               onBlur={handleBlur}
                                               value={values.secondary_distributor}
                                        />

                                        <label className='form-f-label'>How you heard about NOON?</label>
                                        <label className='second-f-label'>Select Options:</label>
                                        <div className='box--outline-comp'>
                                            <div className='checkbox-group-content'>
                                                <FieldArray
                                                    name='additional_information_hearAboutNoon'
                                                    render={arrayHelpers => (
                                                        <div>
                                                            {refferalOpts.map(option => (
                                                                <div key={option.id}>
                                                                    <input
                                                                        name='additional_information_hearAboutNoon'
                                                                        type='checkbox'
                                                                        value={option.id}
                                                                        checked={values.additional_information_hearAboutNoon.includes(option.id)}
                                                                        onChange={event => {
                                                                            if (event.target.checked) {
                                                                                arrayHelpers.push(option.id);
                                                                            }
                                                                            else {
                                                                                const idx = values.additional_information_hearAboutNoon.indexOf(option.id);
                                                                                arrayHelpers.remove(idx);
                                                                            }
                                                                        }}
                                                                    /> {option.display}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>

                                        <div className='toggle-switch-gr'>
                                            <input
                                                type='checkbox'
                                                className='toggle--input--btn'
                                                name='experience_with_noon'
                                                checked={values.experience_with_noon}
                                                onChange={handleChange}
                                            />
                                            <p className='toggle-in-label'>Do you have Experience installing
                                                NOON?</p>
                                        </div>

                                        <div className='error-box-cont'>
                                            {this.state.isError === true ?
                                                <p className='submission-error-text'>Ooops something went wrong!
                                                    Please try again later</p> :
                                                null
                                            }
                                        </div>


                                        {dirty === true && isValid === true && isDisabled === true ?
                                            <button type='submit' className='form-f-button' onClick={e => this.handleSubmitErr(e)}> Save</button> :
                                            <button type='submit' className='form-f-button'> Save</button>
                                        }

                                    </Form>
                                )}

                            </Formik>
                        </div>:
                        <Loader/>
                    }
                </div>
            </section>
        )
    }

}


// WEBPACK FOOTER //
// ./src/routes/AdminCreateReseller/index.js